import React from 'preact/compat';
import { useState } from 'preact/hooks';

import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Label from './Label';
import colors from '../colors';

const TextInput = ({id, label, value, setValue, placeholder, changeDelay=300, description}) => {
    const [lastTimeout, setLastTimeout] = useState(null);
    const [lastValue, setLastValue] = useState(null);

    const onChange = (e) => {
        const value = e.target.value;
        clearTimeout(lastTimeout);
        setLastValue(value);
        const timeout = setTimeout(() => {
            setValue(value);
        }, changeDelay);
        setLastTimeout(timeout);
    }

    return (
    <FormControl>
        <Label id={id} label={label} description={description}/>
        <TextField
            required
            id={id}
            value={lastValue !== null ? lastValue : value}
            onChange={onChange}
            variant="outlined"
            className="text-field"
            placeholder={placeholder}
            InputProps={{
                sx: {
                    width: '256px',
                    height: '40px',
                    borderRadius: '4px',
                    backgroundColor: colors.inputBackground,
                    borderColor: colors.inputBorder,
                    borderSize: '1px',
                    fontSize: '16px',
                    fontWeight: 400,
                    color: colors.inputText,
                    paddingLeft: 0,
                    '& .MuiInputBase-input': {
                        marginTop: '2px'
                    },
                    '&.Mui-focused > .MuiOutlinedInput-notchedOutline, &:hover > .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.option
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        inset: 0,
                        '& legend': {
                            display: 'none'
                        }
                    }
                }
            }}
        />
    </FormControl>
    );
};

export default TextInput;
